import { createAction, props } from '@ngrx/store';
import { SensorModel } from '@models/sensor.model';

export const loadVendorSensors = createAction(
  '[Sensors] Load Vendor Sensors',
  props<{ vendor: SensorModel.Provider }>(),
);

export const loadVendorSensorsSuccess = createAction(
  '[Sensors] Load Vendor Sensors Success',
  props<{ vendor: SensorModel.Provider; sensors: SensorModel.Halo.SensorMetadataBase[] | SensorModel.Disruptive.SensorMetadataBase[] }>(),
);

export const loadVendorSensorsFail = createAction(
  '[Sensors] Load Vendor Sensors Fail',
  props<{ vendor: SensorModel.Provider; error?: string }>(),
);

export const loadSensorById = createAction(
  '[Sensors] Load Sensor By Id',
  props<{ sensorId: string }>(),
);

export const loadSensorByIdSuccess = createAction(
  '[Sensors] Load Sensor By Id Success',
  props<{ sensor: SensorModel.Sensor }>(),
);

export const loadSensorByIdFail = createAction(
  '[Sensors] Load Sensor By Id Fail',
  props<{ sensorId: string; error?: string }>(),
);

export const upsertSensor = createAction(
  '[Sensors] Upsert Sensor',
  props<{ sensor: SensorModel.Sensor }>(),
);

export const upsertSensorSuccess = createAction(
  '[Sensors] Upsert Sensor Success',
);

export const upsertSensorFail = createAction(
  '[Sensors] Upsert Sensor Fail',
  props<{ error?: string }>(),
);

export const deleteSensors = createAction(
  '[Sensors] Delete Vendor Sensors',
  props<{ sensorId: string }>(),
);

export const deleteSensorsSuccess = createAction(
  '[Sensors] Delete Vendor Sensors Success',
);

export const deleteSensorsFail = createAction(
  '[Sensors] Delete Vendor Sensors Fail',
  props<{ error?: string }>(),
);

export const createSensor = createAction(
  '[Sensors] Create Sensor',
  props<{ sensor: SensorModel.Sensor }>(),
);

export const createSensorSuccess = createAction(
  '[Sensors] Create Sensor Success',
);

export const createSensorFail = createAction(
  '[Sensors] Create Sensor Fail',
  props<{ error?: string }>(),
);

export const pressSaveSensor = createAction('[Sensors] Press Save Sensor');

export const pressCreateSensor = createAction('[Sensors] Press Create Sensor');

export const resetCurrentSensor = createAction('[Sensors] Reset Current Sensor');

export const setCanDeactivate = createAction(
  '[Sensors] Set Can deactivate',
  props<{ canDeactivate: boolean }>(),
);
